
import React,{useEffect,useState} from 'react';
import styled from 'styled-components';
import { AppState } from '../../store';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { useHistory } from 'react-router-dom';
import { setCurrentCategory, setSubCategoriesStatus,getCategory, setMenuCategory } from '../../store/categories/functions';
import {ListCard, ListItem, Empty} from '../elements'
import { CONSTS } from '../elements/_constants';
type BaseFrameProps = {
    className?: string,
    match: any,
    onSetCurrentCategoryId: Function,
    onSetMenuCategory: Function,
    onToggleSubCategories: Function,
    currentCategoryId: number,
    currentCategory: any,
    categories: any,
    parents: number[],
    currentPathName: string
}
const CategoryComponent = (props: BaseFrameProps) => {

    let history = useHistory();
    
    useEffect(() => {
        props.onToggleSubCategories(true);
        return () => {};
    }, [])

    useEffect(() => {
        props.onSetCurrentCategoryId(parseInt(""+props.match.params.id));
        let currentCategory = getCategory(props.categories.items,parseInt(""+props.match.params.id));
        if(currentCategory) {
            props.onSetMenuCategory(parseInt(""+ 
            ((currentCategory.children.length > 0) ? props.match.params.id : currentCategory.parent)
            ));
        }

        if(checkIsParentCategory(parseInt(""+props.match.params.id)) && props.match.path != "/") {
            history.push("/")
        }
        return () => {};
    }, [props.match.params.id,props.categories.items])
    
    const checkIsParentCategory = (categoryId: number) => {
        if (!props.parents.length) return false;
        return (props.parents.indexOf(categoryId)!==-1);
    }
    const showTitle = props.currentCategory && (props.currentCategory.forms.length > 0) && (props.currentCategory.posts.length > 0)
    return (
        <div className={props.className} style={{fontFamily:'dana'}}>
            {props.currentCategory &&
            <SwitchTransition>
                <CSSTransition
                key={props.currentCategory.title} //TODO: May be it's not the best choice
                timeout={{ enter: 300, exit: 300 }}
                classNames="fade"
                >
                    <div style={{width:'100%'}}>
                        <div className="_a-row">
                            
                            {props.currentCategory.forms.length>0 && <ListCard
                                className="_list-card"
                                title={showTitle ? "اسناد" : ""}
                                items={props.currentCategory.forms}
                                renderItem={(v: any,k: any)=>
                                    <ListItem key={k} to={`${props.match.url}/forms/${v.id}`} className="_list-item" meta={<div className="_icon icon-icons8-back"/>}>
                                    {v.title}
                                    </ListItem>
                                }
                            />}

                            {props.currentCategory.posts.length>0 && <ListCard
                                className="_list-card"
                                title={showTitle ? "مدارک" : ""}
                                items={props.currentCategory.posts}
                                renderItem={(v: any,k: any)=>
                                    <ListItem key={k} to={`${props.match.url}/posts/${v.id}`} className={`_list-item ${!v.verified ? '--warning' : ''}`} meta={<div className="_icon icon-icons8-back"/>}>
                                    {v.title}
                                    </ListItem>
                                }
                            />}

                            {(props.currentCategory.forms.length == 0 && props.currentCategory.posts.length == 0) &&
                                <Empty description="اسناد یا مدارکی در این دسته موجود نیست"/>
                            }
                            
                        </div>
                    </div>
                </CSSTransition>
            </SwitchTransition>
            }
        </div>
    )
}
const Category = styled(CategoryComponent)`
    /* padding-left: 29px; */
    @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) { 
        padding: 15px;
    }
    ._a-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) { 
            flex-direction: column;
        }
    }
    ._list-card {
        width: 100%;
        margin-left:25px;
        .--warning{
            border-right:3px solid rgba(255, 247, 0, .5);
        }
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) { 
            width: 100%;
            margin-bottom: 10px;
        }
    }
`
const mapStateToProps = (state: AppState) => ({
  categories: state.categories,
  currentCategory: getCategory(state.categories.items,state.categories.currentCategoryId),
  currentCategoryId: state.categories.currentCategoryId,
  parents: state.categories.parents,
  currentPathName: state.base.path
});

const mapDispatchToProps = (dispatch:any) => {
    return {
      onSetCurrentCategoryId  : (id: number)      =>{
        dispatch(setCurrentCategory(id));
      },
      onSetMenuCategory  : (categoryId: number)      =>{
        dispatch(setMenuCategory(categoryId));
      },
      onToggleSubCategories   : (open: boolean)   =>{
        dispatch(setSubCategoriesStatus(open));
      }
    };
  };
  
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(Category));
